export enum ActionType {
    ADD_DRAWING = 'ADD_DRAWING',
    REMOVE_DRAWING = 'REMOVE_DRAWING',
    UPDATE_LAYOUT = 'UPDATE_LAYOUT',
    MULTI_PANE_SELECT = "MULTI_PANE_SELECT",
    ADD_INDICATOR = "ADD_INDICATOR",
    REMOVE_INDICATOR = "REMOVE_INDICATOR",
    TIME_BUCKET = "TIME_BUCKET",
    CHART_TYPE = "CHART_TYPE",
    CANDLE_MOVE_FORWARD_BACKWARD = ' CANDLE_MOVE_FORWARD_BACKWARD',
    ON_TIME_RANGE_CHANGE = 'ON_TIME_RANGE_CHANGE',
    CHANGE_WIDGET_TYPE = ' CHANGE_WIDGET_TYPE',
    ZOOM_IN_OUT = ' ZOOM_IN_OUT',
    SECURITY_CHANGE = 'SECURITY_CHANGE',
    ADD_COMPARE_SECURITY_INDICATOR = 'ADD_COMPARE_SECURITY_INDICATOR',
    REMOVE_COMPARE_SECURITY_INDICATOR = 'REMOVE_COMPARE_SECURITY_INDICATOR',

    SIMULATOR_TIME_CHANGE = 'SIMULATOR_TIME_CHANGE',
    SIMULATOR_ORDERS_CHANGED = 'SIMULATOR_ORDERS_CHANGED',
}
